import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'prov_approximate_of_wrkrs_who_can_communicate_in_the_primary_la'

export const dataPointDefinition = {
  retracedId: 'prov_approximate_of_wrkrs_who_can_communicate_in_the_primary_la',
  name: 'Please provide approximate % of workers who can communicate in the primary language spoken at the facility:',
  description:
    "This should be the approximate % of workers who can speak and understand this language. They may speak other languages as well.\r\r\n \r\r\nWorkers are persons working on/with the facility's product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them.",
  meta: {
    unit: 'PERCENTAGE',
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PERCENTAGE',
      name: 'Percentage',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
      unit: {
        type: 'string',
        enum: ['PERCENTAGE'],
        minLength: 1,
      },
    },
    required: ['value', 'unit'],
  },
  externalIds: [
    {
      id: 'fp-nl-13',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 2070,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
